import { render } from "./ComposeProductModal.vue?vue&type=template&id=b0bfb972"
import script from "./ComposeProductModal.vue?vue&type=script&lang=js"
export * from "./ComposeProductModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__